var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var RemoveEmptyConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
import { validateSourceWithDetail } from './validation/validateHelper';
const schema = {
    $id: 'urn:wisepipe-common-pipe:RemoveEmptyConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { type: 'string', minLength: 1 },
            uniqueItems: true
        }
    },
    required: ['columns']
};
let RemoveEmptyConfig = RemoveEmptyConfig_1 = class RemoveEmptyConfig extends ToolConfig {
    constructor(columns, customFormats) {
        super(ToolType.REMOVE_EMPTY, customFormats);
        this.columns = columns;
        JSON.validate(this, RemoveEmptyConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return RemoveEmptyConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return RemoveEmptyConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return RemoveEmptyConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return RemoveEmptyConfig_1.outs;
    }
    static get in() {
        return RemoveEmptyConfig_1.ins[0];
    }
    static get out() {
        return RemoveEmptyConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.REMOVE_EMPTY.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.CLEAN], this.ins, this.outs, ['remove rows'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        if (source) {
            const exp = tsb.export(this.out);
            this.copyAllInsAndReturnDependents(exp, this.in, source, this.columns);
            exp.initializeColumnFormats().setColumnFormats(this.customFormats);
        }
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        const inputs = new Set(this.columns);
        const sourceValidationResult = validateSourceWithDetail(source, inputs, []);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
};
RemoveEmptyConfig = RemoveEmptyConfig_1 = __decorate([
    JsonSchema(schema),
    JsonDiscriminatorValue(ToolType.REMOVE_EMPTY)
], RemoveEmptyConfig);
export { RemoveEmptyConfig };
//# sourceMappingURL=removeEmptyConfig.js.map